import type {
  TranslatePlugin,
  PluginContext,
  PageTranslateConfig,
  ParagraphTranslateConfig,
} from '../types';

export abstract class BasePlugin implements TranslatePlugin {
  abstract name: string;
  protected ctx!: PluginContext;
  protected destroyed = false;

  abstract init(
    ctx: PluginContext,
    config: PageTranslateConfig | ParagraphTranslateConfig,
  ): void | Promise<void>;

  abstract destroy(): void;

  protected async waitForReady(delay: number = 0): Promise<void> {
    return new Promise(resolve => {
      const onReady = () => {
        if (delay > 0) {
          setTimeout(resolve, delay);
        } else {
          resolve();
        }
      };
      if (document.readyState !== 'loading') {
        onReady();
      } else {
        document.addEventListener('DOMContentLoaded', onReady, { once: true });
      }
    });
  }
}
